/**
 * Quickshop
 */

class ProductCardQuickshop extends HTMLElement {
  constructor() {
    super()
    this.SECTION_ID = this.dataset.sectionId || "product-card-quickshop"
  }
  connectedCallback() {
    // add this because of a Chromium bug
    let intervId
    const check = () => {
      if (this.childElementCount > 0 && this.querySelector(`[data-add-to-cart]`)) {
        clearInterval(intervId)
        intervId = null
        this.init()
      }
    }
    intervId = setInterval(check, 200)
  }
  init() {
    this.setUpElements()
    // Set variant data and default variant id if there is only 1
    if (this.variantData.length === 1) {
      this.currentVariant = this.variantData[0]
    }
    this.addEventListener("change", this.onVariantChange)
  }
  setUpElements() {
    this.CTA = this.querySelector(`[data-add-to-cart]`)
    this.CTA?.addEventListener("click", () => {
      if (this.CTA.hasAttribute("data-reveal-options")) {
        this.revealOptions()
      } else {
        this.addToCart()
      }
    })
    this.variantData = JSON.parse(this.querySelector(`[type="application/json"]`).textContent)
  }
  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.addToCart()
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(`[data-fieldset] input:checked`),
      (option) => option.value
    )
  }
  updateMasterId() {
    this.currentVariant = this.variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
    this.dataset.currentVariantId = this.currentVariant ? this.currentVariant.id : null
  }
  revealOptions() {
    this.querySelector("form").classList.remove("hidden")
    this.CTA.classList.add("hidden")
  }
  reset() {
    this.querySelector("form").classList.add("hidden")
    this.CTA.classList.remove("hidden")
    this.querySelectorAll(`[data-fieldset]:not(.hidden) input`).forEach((input) => {
      input.checked = false
    })
    this.removeAttribute("data-current-variant-id")
  }
  addToCart() {
    if (!this.currentVariant || this.currentVariant == 0) {
      return
    }
    let line_item_properties = {}
    if (this.querySelector(`[data-pre-order]`)) {
      line_item_properties["NOTE"] = this.querySelector(`[data-pre-order]`).innerText
    }
    const formData = new FormData(this.querySelector("form"))
    for (const pair of formData.entries()) {
      if (pair[0].includes("properties") && pair[1].length) {
        let name = pair[0].split("properties[")[1].replace("]", "")
        line_item_properties[name] = pair[1]
      }
    }
    CartJS.addItem(this.currentVariant.id, 1, line_item_properties, {
      success: (data, textStatus, jqXHR) => {
        // Open Mini Cart
        window.setTimeout(function () {
          $("body").addClass("mini-cart-open")
          $("#mini-cart-title-id").focus()
        }, 100)
        this.reset()
      },
      error: (jqXHR, textStatus, errorThrown) => {
        console.log(errorThrown)
      }
    })
  }
}

customElements.define("product-card-quickshop", ProductCardQuickshop)
